<wdpr-toast 
  class="wdpr-toast-custom"
  #wdprtoast
  [message]="toastAttr.message"
  [success]="toastAttr.success"
  [dismissable]="toastAttr.dismissable"
>
</wdpr-toast>
